// extracted by mini-css-extract-plugin
export var bold = "_se-0";